var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListingPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_918_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26367 9.84036V13.3657H6.44894C6.63039 13.3658 6.81014 13.3315 6.97782 13.265C7.14544 13.1984 7.29784 13.1009 7.42618 12.9779L13.5503 7.10899C13.8099 6.86077 13.9559 6.52394 13.9565 6.17246V1.21094H10.2779V8.51453C10.2781 8.68987 10.242 8.86352 10.1717 9.02537C10.1013 9.18722 9.99816 9.33405 9.86811 9.45741C9.73807 9.58076 9.58371 9.67815 9.41413 9.74388C9.24449 9.80961 9.06298 9.84241 8.88001 9.84036H1.26367Z",
    fill: "#736CF5",
    stroke: "#736CF5",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7225 13.1552V9.62988H17.5373C17.3558 9.62988 17.176 9.66408 17.0084 9.73066C16.8407 9.79718 16.6883 9.89469 16.56 10.0177L10.4359 15.8866C10.3076 16.0096 10.2058 16.1556 10.1364 16.3163C10.067 16.477 10.0312 16.6492 10.0312 16.8231V21.7893H13.7099V14.4796C13.7099 14.3055 13.7457 14.1332 13.8152 13.9724C13.8848 13.8116 13.9867 13.6655 14.1152 13.5425C14.2437 13.4196 14.3962 13.322 14.5641 13.2556C14.7319 13.1891 14.9118 13.1551 15.0934 13.1552H22.7225Z",
    fill: "#736CF5",
    stroke: "#736CF5",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_918_1089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingPrice);
export default __webpack_public_path__ + "static/media/listing-price.9c93d766f96e064e20c89da7fb17ea25.svg";
export { ForwardRef as ReactComponent };